<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed, watch } from "vue";
import ArticlePage from "../components/articlePage/Index.vue";
import BaseLayout from "../components/layout/BaseLayout.vue";

const route = useRoute();
const articleId = computed(() => route.params.id as string);

watch(
  () => articleId.value,
  () => {
    window.scrollTo(0, 0);
  }
);
</script>

<template>
  <BaseLayout>
    <ArticlePage :articleId="articleId" />
  </BaseLayout>
</template>
